import { ElementType, ReactNode } from "react";

import { cn } from "@verse_core/shared_components/ClassName";

type HeadingProps = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  as?: ElementType;
};

export const HeadingLG = ({
  children,
  className,
  as: Component = "h4",
  dataTestId,
}: HeadingProps) => {
  return (
    <Component
      className={cn(
        "tw-font-degular tw-text-[1.25em] tw-font-medium tw-leading-[150%] tw-tracking-[-0.01em] tw-text-gray-0",
        className,
      )}
      data-testid={dataTestId}
    >
      {children}
    </Component>
  );
};
